module.exports = __webpack_public_path__ + "../resources/img/ic_re_check_glass_img.b72236be.svg";